/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProcessedEmailDto { 
    id: string;
    recipient: string;
    sender: string;
    subject: string;
    timestamp: string;
    s3Key: string;
    status: ProcessedEmailDto.StatusEnum;
}
export namespace ProcessedEmailDto {
    export const StatusEnum = {
        processed: 'processed'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


